// src/apps/secret/routes/index.ts

import type { RouteRecordRaw } from 'vue-router';

import fileRoutes from './file';
import incomingRoutes from './incoming';
import receiptRoutes from './receipt';
import secretRoutes from './secret';

const routes: RouteRecordRaw[] = [
  ...receiptRoutes,
  ...secretRoutes,
  ...incomingRoutes,
  ...fileRoutes,
];

export default routes;
